import { LANGUAGE_MAP, LANGUAGE_TYPE } from "@web3auth/auth";
import { createI18n } from "vue-i18n";

import en from "./i18n/english.json";

const i18n = createI18n({
  locale: "en", // set locale
  fallbackLocale: "en",
  messages: { en }, // set locale messages
  legacy: false,
});

const loadedLanguages = new Set(["en"]); // our default language that is preloaded

function setI18nLanguage(lang: string) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  i18n.global.locale.value = lang;
  // This is okay to ts-ignore because we use dynamic loading of languages
  return lang;
}

export async function loadLanguageAsync(lang: LANGUAGE_TYPE): Promise<string> {
  if (i18n.global.locale.valueOf() === lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }
  // If the language was already loaded
  if (loadedLanguages.has(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language hasn't been loaded yet
  // TODO: check i18n implementation in other vite projects
  return import(`./i18n/${LANGUAGE_MAP[lang]}.json`).then((messages) => {
    i18n.global.setLocaleMessage(lang, messages.default);
    loadedLanguages.add(lang);
    return setI18nLanguage(lang);
  });
}

export default i18n;
